import { API7 } from "../baseApi";

const getUserState = async (no) => {
    try {
        const response = await API7.get(`user/user_info?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const getUserWallet = async (no) => {
    try {
        const response = await API7.get(`user/get_userbalance_list?user_no=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postStartTrading = async (no) => {
    try {
        const response = await API7.post(`user/start_trading?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postChargeSeed = async (userNo,seed) => {
    try {
        const response = await API7.post(`user/charge_seed?retri_id=${userNo}&seed=${seed}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postResetUser = async (no) => {
    try {
        const response = await API7.post(`user/reset_user?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

export default {
    getUserState,
    postStartTrading,
    postResetUser,
    getUserWallet,
    postChargeSeed,
};
